(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/best-bet-rows/assets/javascripts/use-draw-result-outcomes.js') >= 0) return;  svs.modules.push('/components/tipsen/best-bet-rows/assets/javascripts/use-draw-result-outcomes.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo;
const useObservedDrawResult = svs.components.tipsen.hooksWager.useObservedDrawResult;
const defaultReturn = [[], [], undefined];
const useDrawResultOutcomes = _ref => {
  let wagerId = _ref.wagerId;
  const _useObservedDrawResul = useObservedDrawResult({
      wagerId
    }),
    current = _useObservedDrawResul.current;
  const _current = _slicedToArray(current, 3),
    drawResults = _current[0],
    winDivisions = _current[1],
    multiForecast = _current[2];
  const multiForecastEventNumberIndex = useMemo(() => {
    if (multiForecast) {
      return multiForecast.eventNumberIndex;
    }
    return undefined;
  }, [multiForecast]);
  return useMemo(() => {
    if (!winDivisions) {
      return defaultReturn;
    }
    const newDrawResultOutcomes = drawResults.map(_ref2 => {
      let outcome = _ref2.outcome;
      return outcome[0];
    });
    const newWinDivisions = winDivisions.map(_ref3 => {
      let winDiv = _ref3.winDiv;
      return winDiv;
    }).sort((a, b) => a - b);
    return [newDrawResultOutcomes, newWinDivisions, multiForecastEventNumberIndex];
  }, [drawResults, winDivisions, multiForecastEventNumberIndex]);
};
setGlobal('svs.tipsen.components.bestBetRows.useDrawResultOutcomes', useDrawResultOutcomes);

 })(window);